// extracted by mini-css-extract-plugin
export var container = "_cd-1";
export var cornerButtonContainer = "_cd-6";
export var disabled = "_cd-2";
export var dragActive = "_cd-3";
export var fileContainer = "_cd-5";
export var hiddenInput = "_cd-4";
export var widthContainer = "_cd-0";